// TODO 不包含原 util 的上报逻辑，后续需补充
import { createTraceData } from '@cvte/easy-report';
import { getDefaultParam } from './method';

const DataReport = function () {
  if (typeof window === 'undefined') {
    return;
  }

  this.dataReportId = window.__INITIAL_STATE__.dataReportId;
  this.dataParams = getDefaultParam();
};

DataReport.prototype = {
  setDataParams(config) {
    this.dataParams = {
      ...this.dataParams,
      ...config,
    };
  },
  // 数据上报入口 异步
  dataReportLater(name, params) {
    const _that = this;
    const reportParams = { ..._that.dataParams, ...params, ...createTraceData() };
    // eslint-disable-next-line no-undef
    _faq.push(['trackEvent', name, reportParams, _that.dataReportId]);
  },
  // 数据上报入口 同步
  dataReportNow(name, params) {
    const _that = this;
    const reportParams = { ..._that.dataParams, ...params, ...createTraceData() };
    if (window.$fa) {
      window.$fa.trackEvent(name, reportParams, _that.dataReportId);
    } else {
      _that.dataReportLater(name, params);
    }
  },
};

const DataReportInst = new DataReport();
export default DataReportInst;

// 成长历程H5-活动曝光
export const reportGrowthHomeView = () => {
  DataReportInst.dataReportNow('growth_home_view');
};

// 成长历程H5-进入历程生成
export const reportGrowthHomeEnter = () => {
  DataReportInst.dataReportNow('growth_home_enter');
};

// 成长历程H5-点击我要见证
export const reportGrowthWitnessClick = () => {
  DataReportInst.dataReportNow('growth_witness_click');
};

/**
 * 成长历程H5-点击分享按钮
 * @param {string} buttonName 按钮名称(保存图片 | 我要分享)
 */
export const reportGrowthShare = (buttonName) => {
  DataReportInst.dataReportNow('growth_share', { buttonName });
};

// 成长历程H5-扫描二维码
export const reportGrowthScan = () => {
  DataReportInst.dataReportNow('growth_scan');
};

// 成长历程H5-点击分享tap
export const reportGrowthShareWxClick = () => {
  DataReportInst.dataReportNow('growth_share_wx_click');
};

// 成长历程H5-点击获取我的专属纪念
export const reportGrowthShareHomeClick = () => {
  DataReportInst.dataReportNow('growth_share_home_click');
};

// pc 端拦截曝光
export const reportPcApiProtectVerifyView = (params) => {
  DataReportInst.dataReportNow('pc_api_protect_verify_view', { ...params });
};

// pc 端拦截解锁
export const reportPcApiProtectVerifyUnprotect = (params) => {
  DataReportInst.dataReportNow('pc_api_protect_verify_unprotect', { ...params });
};
